<div class="toggle-block">
  <button type="button" class="toggle-header" (click)="toggleExpanded()" [attr.aria-expanded]="expanded()">
    <span class="toggle-icon-wrapper" [class.expanded]="expanded()">▶</span>
    <span class="toggle-title">{{ block().title }}</span>
  </button>

  @if (expanded()) {
    <div class="toggle-content">
      <ng-container *ngComponentOutlet="contentRenderer(); inputs: { blocks: block().content }" />
    </div>
  }
</div>
